import Message from '@/Messages/Message';
import ComponentManager from '@/Management/ComponentManager';

export default class ListViewExitedMessage extends Message {

    public constructor(params: any) {
        super(params);
    }
}

ComponentManager.setMessage('ListViewExitedMessage', ListViewExitedMessage, 'RADPresentation.HTMLClient.DefaultViewExtensions');